import { render } from "./CountChart.vue?vue&type=template&id=c8b4212e"
import script from "./CountChart.vue?vue&type=script&lang=js"
export * from "./CountChart.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/nice-life-contract/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__